<template>
	<div class="customer-template-setting">
		<v-layout class="py-3 px-3">
			<v-flex class="">
				<div class="fw-600 sub-heading primary--text">Integration</div>
			</v-flex>
			<v-spacer></v-spacer>
			<v-flex class="d-flex justify-content-end">
				<v-btn class="" dense tile v-on:click="goBack()">
					<v-icon class="ml-1">mdi-arrow-left</v-icon>
					Back
				</v-btn>
			</v-flex>
		</v-layout>
		<div class="border pb-3 mb-5">
			<v-layout class="py-2 px-4 blue lighten-5">
				<v-flex class="">
					<div class="fw-600 sub-heading primary--text text-capitalize">Zoom Integration</div>
				</v-flex>
				<v-spacer></v-spacer>
				<v-flex class="d-flex justify-content-end">
					<v-btn
						class="white--text"
						dense
						tile
						color="blue darken-4"
						v-on:click="updateIntegrationSetting()"
					>
						Update
					</v-btn>
				</v-flex>
			</v-layout>
			<v-layout class="px-4 py-2">
				<v-row>
					<v-col cols="12" lg="6" md="6">
						<label for="client_id">Client Id</label>
						<v-text-field outlined id="client_id" hide-details v-model="zoom.client_id"></v-text-field>
					</v-col>
					<v-col cols="12" lg="6" md="6">
						<label for="client_secret">Client Secret</label>
						<v-text-field
							outlined
							id="client_secret"
							hide-details
							v-model="zoom.client_secret"
						></v-text-field>
					</v-col>
					<!-- <v-col cols="12" lg="4" md="4">
						<label for="number-length">Number Length</label>
						<v-text-field
							outlined
							id="number-length"
							type="number"
							hide-details
							v-model="setting.number_length"
						></v-text-field>
					</v-col> -->
				</v-row>
			</v-layout>
		</div>
	</div>
</template>
<script>
import { GET, PATCH } from "@/core/services/store/request.module";
import { SET_MESSAGE } from "@/core/services/store/common.module";

export default {
	name: "IntegrationSetting",
	data() {
		return {
			zoom: {
				client_id: null,
				client_secret: null,
			},
		};
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		getIntegrationSetting() {
			this.$store
				.dispatch(GET, { url: `setting/integration` })
				.then((data) => {
					this.zoom = data;
				})
				.catch((error) => {
					console.log({ error });
				});
		},
		updateIntegrationSetting() {
			this.pageLoading = true;
			this.$store
				.dispatch(PATCH, {
					url: `setting/integration`,
					data: this.zoom,
				})
				.then(() => {
					this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Zoom integration updated successfully." },
					]);
				})
				.catch((error) => {
					console.log({ error });
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
	},
	watch: {
		"$route.query": {
			handler(query) {
				if (query && query.tab == "integration") {
					this.getIntegrationSetting();
				}
			},
		},
	},
	mounted() {
		this.getIntegrationSetting();
	},
};
</script>
